import { render } from "./AccompPalliatifResume.vue?vue&type=template&id=817f71c0"
import script from "./AccompPalliatifResume.vue?vue&type=script&lang=js"
export * from "./AccompPalliatifResume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__